import { render, staticRenderFns } from "./AdminReservation.vue?vue&type=template&id=f26db572&"
import script from "./AdminReservation.vue?vue&type=script&lang=js&"
export * from "./AdminReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports